@if (SCHEDULE_ITEMS != null) {
    <cb-table
        class="cb-margin-top schedule-items-house-area-table"
        label="Schedule Items"
        [loaded]="true"
        [minWidth]="1000"
        [hideDefaultTable]="true"
    >
        <table cbTable>
            <thead>
                <tr>
                    <td></td>
                    <td>Apply Tag</td>
                    <td>Name</td>
                    <td>Cost Type</td>
                    <td>Product Category Path</td>
                    <td>Tag(s)</td>
                    <td>Active</td>
                    <td>Req Child</td>
                    <td></td>
                </tr>
            </thead>
            <tbody
                cdkDropList
                [cdkDropListData]="parentSlotsArray"
                [cdkDropListDisabled]="!reorderingEnabled"
                (cdkDropListDropped)="drop($event)"
                class="parent-slot"
                [ngClass]="ENABLE_REORDERING"
            >
                @for (parentSlot of parentSlotsArray; track parentSlot; let i = $index) {
                    <tr
                        cdkDrag
                        [cdkDragData]="parentSlot"
                        cdkDragPreviewClass="cb-table-drag-preview"
                    >
                        <td>
                            <button
                                mat-icon-button
                                [disabled]="
                                    !childSlotsDict[parentSlot.id]?.length || reorderingEnabled
                                "
                                (click)="
                                    expandedParents[parentSlot.id] = !expandedParents[parentSlot.id]
                                "
                            >
                                <mat-icon>
                                    {{
                                        !reorderingEnabled &&
                                        expandedParents[parentSlot.id] &&
                                        childSlotsDict[parentSlot.id]?.length
                                            ? 'arrow_drop_up'
                                            : 'arrow_drop_down'
                                    }}
                                </mat-icon>
                            </button>
                        </td>
                        <td>
                            <mat-checkbox
                                name="selectedSlots"
                                [checked]="selectedItems[parentSlot.id]"
                                (change)="itemSelected(parentSlot)"
                            ></mat-checkbox>
                        </td>
                        <td>
                            <div class="flex flex-row start-center">
                                <cb-td-text [value]="parentSlot.name"></cb-td-text>
                                <cb-info-popup [tooltip]="parentSlot.description"></cb-info-popup>
                            </div>
                        </td>
                        <cb-td-enum
                            [value]="parentSlot.costType"
                            [enum]="COST_TYPE_ENUM"
                        ></cb-td-enum>
                        <td>
                            @if (parentSlot.categories?.length) {
                                <cb-td-text
                                    [value]="parentSlot?.categories[0]?.categoryPath"
                                ></cb-td-text>
                            }
                            @if (!parentSlot.categories?.length) {
                                <span>-</span>
                            }
                        </td>
                        <cb-td-list [list]="parentSlot.tags"></cb-td-list>
                        <cb-td-checkbox [value]="parentSlot.isActive"></cb-td-checkbox>
                        <td>-</td>
                        <td cbTableShrinkCol cbTableStickyCol="end">
                            <button mat-icon-button (click)="editItemClicked(parentSlot)">
                                <mat-icon>edit</mat-icon>
                            </button>
                        </td>
                    </tr>
                    <!-- Child slots if parent expanded -->
                    @if (!reorderingEnabled && expandedParents[parentSlot.id]) {
                        @for (childSlot of childSlotsDict[parentSlot.id]; track childSlot) {
                            <tr>
                                <td></td>
                                <td>
                                    <mat-checkbox
                                        name="showDeleted"
                                        [checked]="selectedItems[childSlot.id]"
                                        (change)="itemSelected(childSlot)"
                                    ></mat-checkbox>
                                </td>
                                <td>
                                    <div class="flex flex-row start-center">
                                        <cb-td-text [value]="childSlot.name"></cb-td-text>
                                        <cb-info-popup
                                            [tooltip]="childSlot.description"
                                        ></cb-info-popup>
                                    </div>
                                </td>
                                <cb-td-enum
                                    [value]="childSlot.costType"
                                    [enum]="COST_TYPE_ENUM"
                                ></cb-td-enum>
                                <td>
                                    @if (childSlot.categories?.length) {
                                        <cb-td-text
                                            [value]="childSlot.categories[0].categoryPath"
                                        ></cb-td-text>
                                    }
                                    @if (!childSlot.categories?.length) {
                                        <span>-</span>
                                    }
                                </td>
                                <cb-td-list [list]="childSlot.tags"></cb-td-list>
                                <cb-td-checkbox [value]="childSlot.isActive"></cb-td-checkbox>
                                <cb-td-checkbox [value]="childSlot.isRequired"></cb-td-checkbox>
                                <td cbTableShrinkCol cbTableStickyCol="end">
                                    <button mat-icon-button (click)="editItemClicked(childSlot)">
                                        <mat-icon>edit</mat-icon>
                                    </button>
                                </td>
                            </tr>
                        }
                    }
                }
            </tbody>
            @if (parentSlotsArray?.length < 1) {
                <tbody>
                    <tr class="cb-table-footer-row">
                        <td colspan="100%">
                            <cb-info-message
                                message="There are no Schedule Items to display for this House Area"
                                icon="info_circle"
                            ></cb-info-message>
                        </td>
                    </tr>
                </tbody>
            }
        </table>
    </cb-table>
}
